import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaComponent } from './media.component';
import { ElementsModule } from '@shared/elements/elements.module';
import { AvatarComponentModule } from '@components/avatar/avatar-component.module';

@NgModule({
    imports: [
        CommonModule,
        ElementsModule,
        AvatarComponentModule
    ],
    exports: [
        MediaComponent
    ],
    declarations: [
        MediaComponent
    ]
})

export class MediaComponentModule {
}